export const FIELDS = {
  ID: 'id',
  INVENTORY_ID: 'inventoryId',
  SALES_ORDER_ID: 'salesOrderId',
  SODATE: 'soDate',
  CUSTOMER_ID: 'customerId',
  CUSTOMER_NAME: 'customerName',
  SALES_ORDER_LINE_ID: 'salesOrderLineId',
  PART_NUMBER: 'partNumber',
  MANUFACTURER_NAME: 'manufacturerName',
  UNIT_COST: 'unitCost',
  CHARGES: 'charges',
  COST: 'cost',
  QTY_SOLD: 'qtySold',
  QTY_ALLOCATED: 'qtyAllocated',
  QTY_TESTING: 'qtyTesting',
  QTY_SHIPPED: 'qtyShipped',
  QTY_AVAILABLE: 'qtyAvailable',
  STATUS: 'status',
  CREATED_BY_USER_ID: 'createdByUserId',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',
  COMPANY_ID: 'companyId',
  COMPANY_NAME: 'companyName',
  PURCHASE_ORDER_LINE_ID: 'purchaseOrderLineId',
  PART_ID: 'partId',
  VENDOR_PART_NUMBER: 'vendorPartNumber',
  INTERNAL_PN: 'internalPn',
  NSNNUMBER: 'nsnNumber',
  ALT_NUMBER: 'altNumber',
  HARMONIZED_CODE: 'harmonizedCode',
  DESCRIPTION: 'description',
  MANUFACTURER_ID: 'manufacturerId',
  INVENTORY_CLASS_ID: 'inventoryClassId',
  CLASS_NAME: 'className',
  INVENTORY_CATEGORY_ID: 'inventoryCategoryId',
  CATEGORY_NAME: 'categoryName',
  UO_MID: 'uoMId',
  UOM: 'uom',
  PACKAGE_ID: 'packageId',
  PACKAGE: 'package',
  PIECE_PER_PKG: 'piecePerPkg',
  PHYS_PKG: 'physPkg',
  LEAD_FREE: 'leadFree',
  TEMP_RATING: 'tempRating',
  PART_COMMENTS: 'partComments',
  QTY_RECEIVED: 'qtyReceived',
  ON_HAND: 'onHand',
  ALLOCATED: 'allocated',
  RETURNED: 'returned',
  DESTROYED: 'destroyed',
  DATE_CODE: 'dateCode',
  LOT_CODE: 'lotCode',
  REVISION: 'revision',
  CONDITION_ID: 'conditionId',
  CONDITION_NAME: 'conditionName',
  COUNTRY_OF_ORIGIN_ID: 'countryOfOriginId',
  COUNTRY_OF_ORIGIN_NAME: 'countryOfOriginName',
  QTY_ON_HOLD: 'qtyOnHold',
  WAREHOUSE_ID: 'warehouseId',
  WAREHOUSE_NAME: 'warehouseName',
  LOCATION: 'location',
  RACK: 'rack',
  SHELF: 'shelf',
  BIN: 'bin',
  IS_SPLIT: 'isSplit',
  IS_QUARANTINED: 'isQuarantined',
  WARRANTY_ID: 'warrantyId',
  WARRANTY_NAME: 'warrantyName',};